export class Currency {
  currencyId: number;
  name: string;
  isoCode: string;
}

export interface InputCurrencyOption {
  id: number,
  name: string
}
